// AB3 Academy — клиент sandbox_service API.
// Обычно фронт работает с sandbox опосредованно (через learning.startPractice/finishPractice).
// Этот сервис нужен для admin/dev сценариев и для прямого DELETE при «выйти без проверки».
//
// Контракт: handoff Phase 2 §3.1.

import authService from './auth.service';
import type {
  SandboxSessionCreate,
  SandboxSessionOut,
  VerifyResult,
} from '../types/sandbox.types';

const API_URL = '/api/v1';

class SandboxService {
  private async asJson<T>(res: Response, fallbackMessage: string): Promise<T> {
    if (!res.ok) {
      const err = await res.json().catch(() => null);
      throw new Error(err?.detail || fallbackMessage);
    }
    return res.json() as Promise<T>;
  }

  async createSession(payload: SandboxSessionCreate): Promise<SandboxSessionOut> {
    const res = await authService.fetchWithAuth(`${API_URL}/sandbox/sessions`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.asJson<SandboxSessionOut>(res, 'Не удалось создать песочницу');
  }

  async getSession(sandboxId: number | string): Promise<SandboxSessionOut> {
    const res = await authService.fetchWithAuth(`${API_URL}/sandbox/sessions/${sandboxId}`);
    return this.asJson<SandboxSessionOut>(res, 'Песочница не найдена');
  }

  async verifySession(sandboxId: number | string): Promise<VerifyResult> {
    const res = await authService.fetchWithAuth(`${API_URL}/sandbox/sessions/${sandboxId}/verify`, {
      method: 'POST',
    });
    return this.asJson<VerifyResult>(res, 'Не удалось проверить песочницу');
  }

  /**
   * Дропнуть schema + stamp finished_at. Идемпотентно: повторный DELETE
   * на уже-дропнутую возвращает 200 с тем же объектом.
   * Note: backend возвращает 200 (НЕ 204) — handoff §3.1.
   */
  async deleteSession(sandboxId: number | string): Promise<SandboxSessionOut> {
    const res = await authService.fetchWithAuth(`${API_URL}/sandbox/sessions/${sandboxId}`, {
      method: 'DELETE',
    });
    return this.asJson<SandboxSessionOut>(res, 'Не удалось закрыть песочницу');
  }
}

const sandboxService = new SandboxService();
export default sandboxService;
export { sandboxService };
